module.exports = __webpack_public_path__ + "media/share_images/bass-50d75baa.svg";